<template>
  <div class="column full-height">
    <header
      class="row items-center justify-between q-px-2x-md full-width"
      :style="{ height: '76px' }"
    >
      <div class="flex items-center">
        <span class="text-lg text-neutral text-weight-medium q-mr-md">{{
          user?.basicInfo?.role == "buyer"
            ? `Customer Verification Center`
            : `Vendor Verification Center`
        }}</span>
        <PBadge
          class="text-capitalize"
          :label="user?.background_check?.direct_indirect_grading_status_cd"
          :type="user?.background_check?.direct_indirect_grading_status_cd"
        />
      </div>

      <PBtn color="primary" flat round @click="onClose">
        <CloseIcon class="icon" />
      </PBtn>
    </header>

    <q-separator color="neutral-40" />

    <div class="col full-width overflow-auto">
      <div
        :style="{
          position: 'sticky',
          top: '0',
          backgroundColor: 'white',
          zIndex: '2',
        }"
      >
        <div class="q-px-2x-md q-py-md">
          <PTabs
            v-model="activeTab"
            indicator="chip"
            align="justify"
            content-class="overflow-auto"
            outside-arrows
          >
            <PTab
              v-for="({ name, label, icon, iconColor }, index) in tabs"
              :key="index"
              class="text-xs text-weight-medium"
              :class="{ 'text-neutral-70': activeTab !== name }"
              tab-class="chip"
              :style="{ borderRadius: '12px' }"
              :name="name"
              indicator="chip"
            >
              <template #icon>
                <component
                  :is="icon"
                  class="icon--sm q-mr-xs"
                  :class="iconColor"
                ></component>
              </template>
              {{ label }}
            </PTab>
          </PTabs>
        </div>

        <q-separator color="neutral-40" />
      </div>
      <q-tab-panels v-model="activeTab" animated class="col overflow-auto">
        <q-tab-panel name="pre_screening" class="q-pa-none full-height">
          <PreScreeningView />
        </q-tab-panel>
        <q-tab-panel name="direct_verification" class="q-pa-none full-height">
          <DirectIndirectVerificationForm stage="direct_verification" />
        </q-tab-panel>
        <q-tab-panel name="indirect_verification" class="q-pa-none full-height">
          <DirectIndirectVerificationForm stage="indirect_verification" />
        </q-tab-panel>
      </q-tab-panels>
    </div>
  </div>
</template>

<script setup>
import CloseIcon from "assets/icons/close.svg";
import CompleteIcon from "assets/icons/check-round-outline.svg";
import SkipIcon from "assets/icons/skip-round.svg";
import PendingIcon from "assets/icons/time-circle.svg";
import { unref } from "vue";

const { user, userVerificationData } = storeToRefs(useUserStore());
const { toggleVerificationCenterForm } = useUserStore();

const computedDirectVerificationIconData = computed({
  get() {
    let icon;
    let iconColor;
    const directVerificationData =
      unref(userVerificationData).direct_verification;

    if (directVerificationData?.stage_cd == "completed") {
      icon = CompleteIcon;

      iconColor = "text-success-70";
    } else if (directVerificationData?.stage_cd == "skipped") {
      icon = SkipIcon;

      iconColor = "text-neutral-90";
    } else {
      icon = PendingIcon;

      iconColor = "text-neutral-70";
    }

    return { icon, iconColor };
  },
});

const computedIndirectVerificationIconData = computed({
  get() {
    let icon;
    let iconColor;
    const inDirectVerificationData =
      unref(userVerificationData).indirect_verification;

    if (inDirectVerificationData?.stage_cd == "completed") {
      icon = CompleteIcon;

      iconColor = "text-success-70";
    } else if (inDirectVerificationData?.stage_cd == "skipped") {
      icon = SkipIcon;

      iconColor = "text-neutral-90";
    } else {
      icon = PendingIcon;

      iconColor = "text-neutral-70";
    }

    return { icon, iconColor };
  },
});

const activeTab = ref("pre_screening");
const tabs = computed(() => [
  {
    name: "pre_screening",
    label: `PRE-SCREENING`,
    icon: CompleteIcon,
    iconColor: "text-success-70",
  },
  {
    name: "direct_verification",
    label: `DIRECT VERIFICATION`,
    icon: unref(computedDirectVerificationIconData).icon,
    iconColor: unref(computedDirectVerificationIconData).iconColor,
  },
  {
    name: "indirect_verification",
    label: `INDIRECT VERIFICATION`,
    icon: unref(computedIndirectVerificationIconData).icon,
    iconColor: unref(computedIndirectVerificationIconData).iconColor,
  },
]);

const onClose = () => {
  toggleVerificationCenterForm({ open: false, level: 0 });

  activeTab.value = "pre_screening";
};
</script>
